import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";

export const InternalNotesCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  { header: "Internal notes", cell: (row) => row.internalNote || "" };
